<div class="form-checkbox-list" [ngClass]="{ 'check-box-scroll-hidden': !enableScroll, 'overflow-y-auto': !noOverflow }">
	<label *ngIf="checkBoxAll" class="pl-2 custom-checkbox padding-checkbox">
		<mat-checkbox
			[disabled]="readOnly || onlyView"
			[(ngModel)]="allSelect"
			(change)="selectAll()">
			<span
				[ngClass]="{
					'fw-bold': boldSelectAll
				}">
				{{ allPhase }}
			</span>
		</mat-checkbox>
	</label>
	<div *ngFor="let subArea of subAreasOptions">
		<div *ngIf="(hideSelected && !subArea.checked) || !hideSelected">
			<div *ngIf="(onlySelected && subArea.checked) || !onlySelected">
				<label
					*ngIf="!subArea.hidden"
					[ngClass]="{ 'ps-2': !subArea.separator,
				 				'justify-content-center': subArea.separator,
								'justify-content-start': !subArea.separator,
								'd-block': !subArea.separator,
								'd-flex': subArea.separator,
								'font-size-14': subArea.separator,
								'font-size-12': !subArea.separator,
								'cmt-15': subArea.separator,
								'cmt-10': !subArea.separator
							}"				
					class="custom-checkbox padding-checkbox text-black">
					<mat-checkbox
						*ngIf="!subArea.separator"
						type="checkbox"
						[disabled]="readOnly || onlyView"
						[(ngModel)]="subArea.checked"
						(change)="selectOne(subArea)">
						{{ label(subArea) }}
					</mat-checkbox>
				</label>
			</div>
		</div>
	</div>
</div>
